<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav>
        <ul class="footer-menu">
          <li>
          </li>
        </ul>
      </nav>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>
